import type { CSSProperties } from "react";
import { PageContainer, type PageContainerProps } from "./PageContainer";
import { PageHeader, type PageHeaderProps } from "./PageHeader";
import { usePageMetadata } from "./pageMetadata";

export interface PageFrameProps extends PageContainerProps, Omit<PageHeaderProps, "className" | "style"> {
  headerClassName?: string;
  headerStyle?: CSSProperties;
}

/** Ein Kopfbesitzer; der Rahmen besitzt die Abstände, die Seite ihren Zustand und ihre Aktionen. */
export function PageFrame({
  title, objectTitle, titleIcon, subtitle, subtitleFullWidth, titleSuffix, extra, breadcrumb, headerClassName, headerStyle,
  children, ...container
}: PageFrameProps) {
  const metadata = usePageMetadata();
  const hasHeading = (objectTitle !== undefined ? objectTitle : metadata?.title ?? title) != null;
  return <PageContainer {...container}>
    {hasHeading && <PageHeader title={title} objectTitle={objectTitle} titleIcon={titleIcon} subtitle={subtitle} subtitleFullWidth={subtitleFullWidth}
      titleSuffix={titleSuffix} extra={extra} breadcrumb={breadcrumb}
      className={headerClassName} style={headerStyle} />}
    {children}
  </PageContainer>;
}
